import ProductCardWaitlist from '../components/product-card-waitlist';
import animations from '../core/animations'
import UniqueId from 'vue-unique-id'

Vue.use(UniqueId)

const selector = '#search-or-collection-app';
const el = document.querySelector(selector)
if (el != undefined) {
  new Vue ({
    el: el,
    delimiters: ['${', '}'],
    components: {
      'product-card-waitlist': ProductCardWaitlist
    },
    methods: {
      cardBlur(id) {
        var ref = this.$refs[`${ id }-waitlist`];
        if(ref != undefined) {
          Vue.set(ref, 'open', false)
        }
      }
    },
    mounted() {
      animations({
        reset: true,
        threshold: .1
      });
    }
  })
}